// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper';

class GalleryMain {
	constructor() {
		this.selectors = {
			document: document,
			slickGalleryMain: '.slickGalleryMain',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
		// configure Swiper to use modules
		Swiper.use([Navigation, Pagination, EffectCoverflow, Autoplay]);
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		// Swiper for GalleryMain

		var swiper = new Swiper('.swiper-container', {
			effect: 'coverflow',
			grabCursor: true,
		    loop: true,
		    autoplay: true,
		    centeredSlides: true,
		    centeredSlidesBounds: true,
		    slidesPerView: $('.gallery_photos_number').text(),
		    coverflowEffect: {
		      rotate: 50,
		      stretch: 0,
		      depth: 110,
		      modifier: 1,
		      slideShadows: true,
		    },
		    pagination: {
		        el: '.swiper-pagination',
		        clickable: true,
		    },
		    navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		        clickable: true,
		    },
		    breakpoints: {
			    // when window width is >= 310px
			    300: {
			      slidesPerView: 1,
			    },
			    // when window width is >= 769px
			    769: {
			      slidesPerView: $('.gallery_photos_number').text(),
			    }
			}
		});

		this.nodes.document.ready(function() {
			$('.js-popup-gallery').magnificPopup({
				delegate: 'a',
				type: 'image',
				tLoading: 'Loading image #%curr%...',
				mainClass: 'mfp-img-mobile',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0,1]
				},
				image: {
					tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
				}
			});
			$('#js-swiper-prev').on('click', () => {
				$('.swiper-button-prev').click();
			});
			$('#js-swiper-next').on('click', () => {
				$('.swiper-button-next').click();
			});
		});

	}
}
new GalleryMain();